export default __webpack_public_path__ + "static/media/cubo-base.137f6ad3.jpg";